export default {
  name: "GHComponent",
  components: {}
};